import React, { Fragment, Component } from "react";
import Slider, { Settings } from "react-slick";
import isEmpty from "lodash/isEmpty";
import styles from "./styles.module.sass";

interface ImageSize {
  large: string;
  carouselthumb: string;
}

interface GalleryImage {
  ID: number | string;
  sizes: ImageSize;
}

interface ACF {
  gallery: GalleryImage[];
}

interface Data {
  acf: ACF;
}

interface State {
  nav1: Slider | null;
  nav2: Slider | null;
  width: number;
}

interface Props {
  data: Data;
}

class Carousel extends Component<Props, State> {
  private slider1: Slider | null = null;
  private slider2: Slider | null = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
      width: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    window.dispatchEvent(new Event("resize"));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate() {
    if (isEmpty(this.state.nav1) && !isEmpty(this.slider1)) {
      this.setState({
        nav1: this.slider1,
        nav2: this.slider2,
      });
    }
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const navSettings: Settings = {
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      focusOnSelect: true,
    };

    const settings: Settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
    };

    const { data } = this.props;

    return (
      <div className={styles.images}>
        {this.state.width > 767 && (
          <Fragment>
            <Slider
              className={styles.slider}
              asNavFor={this.state.nav2 ?? undefined}
              ref={slider => { this.slider1 = slider; }}
              {...settings}
            >
              {data.acf.gallery.map(image => (
                <div className={styles.sliderItem} key={image.ID}>
                  <img src={image.sizes.large} alt="" />
                </div>
              ))}
            </Slider>
            <div className={styles.thumbListWrapper}>
              <Slider
                className={styles.thumbList}
                {...navSettings}
                asNavFor={this.state.nav1 ?? undefined}
                ref={slider => { this.slider2 = slider; }}
              >
                {data.acf.gallery.map(image => (
                  <div key={`${image.ID}-thumb`} className={styles.thumb}>
                    <img src={image.sizes.carouselthumb} alt="" />
                  </div>
                ))}
              </Slider>
            </div>
          </Fragment>
        )}
        {this.state.width <= 767 && (
          <Fragment>
            {data.acf.gallery.map(image => (
              <div key={`image${image.ID}`} className={styles.sliderItem}>
                <img src={image.sizes.large} alt="" />
              </div>
            ))}
          </Fragment>
        )}
      </div>
    );
  }
}

export default Carousel;